<template>
  <div id="app">
    <header>
      <b-navbar fixed-top>
        <template #brand>
          <b-navbar-item
            tag="router-link"
            :to="{ path: '/' }"
            style="background-color: transparent;"
          >
            <img
              src="https://www.fmi.org/svg/fmi-logo.svg"
              alt="FMI Appointment Scheduler"
              class="is-block"
            />
          </b-navbar-item>
        </template>
        <template #start>
          <b-navbar-dropdown label="Select a Meeting" v-if="user.isAdmin">
            <b-navbar-item
              tag="router-link"
              :to="{
                name: 'MeetingDashboard',
                params: { id: meeting.id }
              }"
              v-for="meeting in filteredMeetings"
              :key="meeting.id"
            >
              {{ meeting.name }}
              <span v-if="meeting.is_archived" class="ml-1 font-bold"
                >[archived]</span
              >
            </b-navbar-item>
          </b-navbar-dropdown>
        </template>

        <template #end>
          <div class="navbar-item" v-if="!user.isLoggedIn">
            <div class="buttons">
              <button class="button is-primary" @click.prevent="logIn">
                <strong>Log in</strong>
              </button>
            </div>
          </div>

          <b-navbar-dropdown v-else :label="user.fullName" right>
            <b-navbar-item tag="div" class="field">
              <button class="button is-fullwidth" @click.prevent="logout">
                Log out
              </button>
            </b-navbar-item>
          </b-navbar-dropdown>
        </template>
      </b-navbar>
    </header>

    <section class="page-body mt-3">
      <div class="container column">
        <router-view :key="$route.fullPath" />
      </div>
    </section>
    <footer class="footer is-hidden-print py-4 px-1 lg:py-12 lg:pb-16">
      <div class="container column lg:flex justify-between">
        <div class="content block">
          <p>
            <span class="mr-1">&copy;</span>
            <span class="copy-year" v-text="copyYear"></span>
            <strong class="is-semibold">FMI</strong>. All rights reserved.
          </p>
          <p>
            <span class="icon mr-1"
              ><i class="fas fa-map-marker-alt" title="Address"></i
            ></span>
            <span>251 18th Street S, Suite 1200, Arlington, VA 22202</span>
          </p>
          <p>
            <span class="icon mr-1"
              ><i class="fas fa-phone" title="Phone"></i></span
            ><span class="mr-4">(202) 452-8444</span>
            <span class="icon mr-1"><i class="fas fa-fax" title="Fax"></i></span
            ><span>(202) 429-4519</span>
          </p>
        </div>

        <div class="content">
          <p class="has-text-right has-text-left-mobile">
            <a href="#">Help</a> &middot;
            <a href="https://www.fmi.org/utility-pages/privacy-policy"
              >Privacy Policy</a
            >
            &middot;
            <a href="https://www.fmi.org/utility-pages/terms-of-use"
              >Terms of Use</a
            >
          </p>
        </div>
      </div>
    </footer>
    <portal-target name="modals"></portal-target>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import auth from '@/services/auth';
import dbhelpers from '@/services/dbhelpers';

export default {
  data() {
    return {
      isMeetingSelectOpen: false,
      isMenuOpen: false,
      meetings: []
    };
  },
  computed: {
    ...mapGetters(['user']),
    ...mapState(['showArchived']),
    selectedMeetingName() {
      let selectedMeeting = this.meetings.filter(meeting => {
        return meeting.id === this.$route.params.id;
      });
      if (selectedMeeting.length) {
        return selectedMeeting[0].name;
      } else {
        return 'Select a Meeting';
      }
    },
    copyYear() {
      return new Date().getFullYear();
    },
    filteredMeetings() {
      let newMeetings = [...this.meetings];

      if (!this.showArchived) {
        newMeetings = newMeetings.filter(meeting => !meeting.is_archived);
      }

      return newMeetings
        .sort((a, b) => {
          return a.start_date.seconds > b.start_date.seconds ? 1 : -1;
        })
        .sort((a, b) => {
          if (a.is_archived && !b.is_archived) {
            return 1;
          }

          if (b.is_archived && !a.is_archived) {
            return -1;
          }

          return 0;
        });
    }
  },
  methods: {
    logIn() {
      auth.fetchJWT();
    },
    logout() {
      auth.logout();
    }
  },
  firestore() {
    return {
      meetings: dbhelpers.getUserMeetings()
    };
  }
};
</script>

<style>
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>



// WEBPACK FOOTER //
// src/App.vue